import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  @Input() title = '';
  @Input() text = '';
  @Input() firstBtn = '';
  @Input() secondBtn = '';
  @Input() modalId = 'confirmModal';
  @Input() type = 'danger'; // info - confirm
  @Output() doAction1: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }
  emitAction1() {
    jQuery('#' + this.modalId).modal('hide');
    this.doAction1.emit();
  }
}
